// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Router from './router'
import Axios from 'axios'
import {apiDomain} from './.env.js'
import Store from './store.js'
import Auth from './config/auth.js'

Vue.use(Auth);

Vue.config.productionTip = false

export const bus = new Vue();

// console.log('stifpler', apiDomain);
Axios.defaults.baseURL = apiDomain;
// For common config
let accessToken = Vue.auth.getToken();
if(accessToken){
  Axios.defaults.headers.common['object_sid'] = accessToken.sid;
  Axios.defaults.headers.common['token'] = accessToken.token;
  Axios.defaults.headers.post["Content-Type"] = "application/json";
}

Router.beforeEach(
  (to, from, next) => {
    if(to.matched.some(record => record.meta.forAuth)) {
      if( ! Vue.auth.isAuthenticated()) {
        Store.commit('saveModule', to.path);
        next({
          path: '/login'
        })
      } else next()
    } else next()
  }
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: Router,
  store: Store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js